export default {
  meta: {
    title: 'Locxx 租户跳转',
    logincallback: '/login/locxxredirect',
  }
};
